"use client";

import { useEffect, useState } from "react";

/**
 * Reactively reads `prefers-reduced-motion: reduce` from the user agent.
 * SSR-safe : returns `false` on the server, then refreshes on mount.
 *
 * Components that rely on transforms / scales / translations should
 * branch on this flag so the experience degrades to plain opacity for
 * users who opted out of motion. Keep usage minimal, most CSS
 * animations should already declare a `@media (prefers-reduced-motion)`
 * fallback when possible.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) {
      return;
    }

    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduced(mql.matches);

    const handler = (event: MediaQueryListEvent) => setReduced(event.matches);

    mql.addEventListener("change", handler);

    return () => mql.removeEventListener("change", handler);
  }, []);

  return reduced;
}
